import React, { Component } from "react";
import { Table, Card } from "react-bootstrap";
import "./Category.css";
import Button from "react-bootstrap/Button";
import CategoryViewModal from "../Category/CategoryViewModal";
import CategoryEdit from './CategoryEdit'
class Category extends Component {
  constructor() {
    super();
    this.state = {
      userShow: false,
      showEdit: false,

      ItemList: ""
    };
  }
  handleShowView = () => {
    this.setState({
      userShow: true,
    });
  };
  handleCloseView = () => {
    this.setState({ userShow: false });
  };
  editmodel = (item) => {

    this.props.fetchCatgryById(item)
    this.setState({
      showEdit: true, ItemList: item
    })

  }
  closeEdtModel = () => {
    this.setState({
      showEdit: false
    })
  }
  componentDidMount() {
    this.props.fetchCatgrys()
  }
  render() {
    console.log("indexxxxxxxxxxxxxxxx", this.props.CategorysList)
    return (
      <div>
        <div>
          <div>
            <div className="userDiv">
              <Card>
                <Card.Header>
                  <h3>Category</h3>
                </Card.Header>
                <Card.Body>
                  <Button
                    className="btncls_add"
                    onClick={() => this.handleShowView()}
                  >
                    ADD
                  </Button>
                  <CategoryViewModal
                    show={this.state.userShow}
                    handleClose={this.handleCloseView}
                    AddCatgrs={this.props.AddCatgrs}
                  />
                  <Table responsive className="userMainTable" bordered>
                    <thead>

                      <tr>
                        <th>Sl No</th>
                        <th>Name</th>
                        <th>Discription</th>
                        <th>Code</th>
                        <th>Active</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.props.CategorysList && this.props.CategorysList.map((item, i) => (
                        <tr key={i}>
                          <td>{i + 1}</td>
                          <td className="userCap">{item.name}</td>
                          <td className="userCap">{item.desc}</td>
                          <td className="userCap">{item.code}</td>
                          <td className="userCap">{item.isActive ? "Yes" : "No"}</td>
                          <td>    <i className="fa fa-edit fa-lg mt-4" onClick={() => this.editmodel(item)} >
                          </i>
                            <CategoryEdit
                              editShow={this.state.showEdit}
                              closemodel={this.closeEdtModel}
                              ItemList={this.state.ItemList} />
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </Card.Body>
              </Card>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Category;
